/* eslint-disable jsx-a11y/no-static-element-interactions */ // TODO: remove
/* eslint-disable jsx-a11y/click-events-have-key-events */ // TODO: remove
import { FC, useEffect, useState, useRef } from 'react';
import Icon from '../../../DataDisplay/Icon/Icon';
import LockedFeatureDialogue from '../../../Compound/LockedFeatureDialogue/LockedFeatureDialogue';
import styles from './FilterableMultiSelectorItem.module.scss';

type FilterableMultiSelectorItemProps = {
  idx: number;
  label: string;
  template?: React.ReactNode;
  isChecked?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isLocked?: boolean;
  labelSize?: string;
  size?: 'xsm' | 'sm' | 'lg';
  itemHeight?: string;
  isCurrentItem?: boolean;
  lockedItemContact?: () => void;
  onClick: (idx: number, isChecked: boolean) => void;
};

const FilterableMultiSelectorItem: FC<FilterableMultiSelectorItemProps> = ({
  idx,
  label,
  isChecked = false,
  isReadOnly = false,
  isDisabled = false,
  isLocked = false,
  isCurrentItem = false,
  size = 'sm',
  labelSize,
  itemHeight,
  lockedItemContact = () => {},
  onClick,
  template,
}) => {
  const [isDialogueVisible, setIsDialogueVisible] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleClick = () => {
    onClick(idx, !checked);
  };

  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // scroll to item if true
    if (isCurrentItem && itemRef.current) {
      itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [isCurrentItem]);

  return (
    <>
      <LockedFeatureDialogue
        isVisible={isDialogueVisible}
        lockedFeature={label}
        cancel={() => {
          setIsDialogueVisible(false);
        }}
        contactOutTeam={lockedItemContact}
      />

      {template ? (
        <div ref={itemRef} onClick={handleClick}>
          {/* TODO: arrow keys going off of list (existing bug) */}
          {template}
        </div>
      ) : (
        <div style={{ height: itemHeight }} ref={itemRef}>
          {isLocked ? (
            <div
              className={styles.lockedItem}
              onClick={() => {
                setIsDialogueVisible(true);
              }}
            >
              <Icon icon="lock2" color="low-light" width="20px" height="20px" />
              <span>{label}</span>
            </div>
          ) : (
            <div
              className={[
                styles.itemContainer,
                isDisabled ? styles.disabled : '',
                isCurrentItem ? styles.currentItem : '',
              ].join(' ')}
              onClick={() => {
                if (!isDisabled && !isReadOnly) {
                  handleClick();
                }
              }}
            >
              <div className={styles.labelContainer}>
                {isChecked && <Icon icon="check" color="primary-dark" width="12px" height="10px" size={size} />}
                <span className={styles.label} style={{ fontSize: labelSize }}>
                  {label}
                </span>
              </div>
            </div>
          )}
        </div>
      )}

      {/* <div style={{ height: itemHeight }} className={template ? styles.customItem : styles.defaultItem} ref={itemRef}>
        {isLocked ? (
          <div
            className={styles.lockedItem}
            onClick={() => {
              setIsDialogueVisible(true);
            }}
          >
            <Icon icon="lock2" color="low-light" width="20px" height="20px" />
            <span>{template || label}</span>
          </div>
        ) : (
          <div
            className={[
              styles.itemContainer,
              isDisabled ? styles.disabled : '',
              isCurrentItem ? styles.currentItem : '',
            ].join(' ')}
            onClick={() => {
              if (!isDisabled && !isReadOnly) {
                handleClick();
              }
            }}
          >
            <div className={styles.labelContainer}>
              {isChecked && !template && (
                <Icon icon="check" color="primary-dark" width="12px" height="10px" size={size} />
              )}
              <span className={styles.label} style={{ fontSize: labelSize }}>
                {template || label}
              </span>
            </div>
          </div>
        )}
      </div> */}
    </>
  );
};

export default FilterableMultiSelectorItem;
